import React, { useCallback, useContext } from 'react'
import SectionFormContainer from '../../components/SectionFormContainer'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import BreedPicker from './components/BreedPicker'
import { GROOMING_PROFILE_KEYS } from './constants'

const ComboMix = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const { attr, title = '', subtext = '' } = props

	const handleSelection = useCallback(
		(breed) => {
			const newValues = { ...wizard_state }

			newValues[attr][0] = breed
			newValues[GROOMING_PROFILE_KEYS.coat_type] = ''
			newValues[GROOMING_PROFILE_KEYS.coat_length] = ''
			newValues[GROOMING_PROFILE_KEYS.grooming_level] = ''
			newValues[GROOMING_PROFILE_KEYS.allowed_grooming_services] = []

			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const handleSecondBreedSelection = useCallback(
		(breed) => {
			const newValues = { ...wizard_state }

			newValues[attr][1] = breed
			newValues[GROOMING_PROFILE_KEYS.coat_type] = ''
			newValues[GROOMING_PROFILE_KEYS.coat_length] = ''
			newValues[GROOMING_PROFILE_KEYS.grooming_level] = ''
			newValues[GROOMING_PROFILE_KEYS.allowed_grooming_services] = []

			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	return (
		<SectionFormContainer
			title={title}
			subtext={subtext}
			titleStyles={{ flex: 0, marginBottom: '1rem' }}
			childrenContainerStyles={{ flex: 0, marginBottom: '5rem' }}>
			<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
				<BreedPicker
					value={wizard_state[attr][0] || ''}
					label="First Breed"
					onSelected={handleSelection}
				/>
				<BreedPicker
					disabled={wizard_state[attr][0] === ''}
					value={wizard_state[attr][1] || ''}
					label="Second Breed"
					onSelected={handleSecondBreedSelection}
				/>
			</div>
		</SectionFormContainer>
	)
}

export default ComboMix
